
import Splide from "@splidejs/splide";

function init() {
	postsCarousel();
}

function postsCarousel() {

	var carousels = document.querySelectorAll(".block-post-carousel .splide");

	if(carousels.length > 0){

		window.utils.forEach(carousels, function (index, carousel) {

			var postsCarousel = new Splide(carousel, {
				type: 'slide',
				gap: '2rem',
				perPage: 4,
				perMove: 1,
				focus: 'left',
				arrows: false,
				autoplay: false,
				pauseOnHover: false,
				speed: 800,
				omitEnd: true,
				updateOnMove: true,
				padding: { left: '3rem', right: '0' },
				pagination: true,
				arrowPath: "M23.71,19.93l.11-.89c-3.04-.35-5.98-1.44-8.53-3.21-3.64-2.26-6.82-5.1-9.46-8.47C3.26,4.14,1.84,1.51,1.84,0H.02C.02,1.99,1.49,4.85,4.41,8.49c2.77,3.54,6.1,6.52,9.89,8.86.93.64,1.9,1.2,2.92,1.68h-.02c.66.32.69,1.33.11,1.73-.04.03-.08.06-.12.09h.03s-.07.04-.1.05c0,0-.02,0-.03.01-.95.46-1.88,1-2.75,1.59-3.81,2.37-7.16,5.36-9.93,8.89-2.92,3.66-4.41,6.52-4.41,8.49h1.82c0-1.51,1.42-4.12,4.01-7.36,2.64-3.37,5.81-6.21,9.49-8.49,2.51-1.75,5.45-2.84,8.49-3.19l-.11-.91Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					1550: {
						perPage: 4,
					},
					1200: {
						perPage: 4,
					},
					992: {
						perPage: 3,
					},
					768: {
						perPage: 2,
					},
					576: {
						perPage: 1,
					},
				},
			});

			postsCarousel.mount();

		});

	}

}

export default { init };